import tinymce, { type Editor } from 'tinymce';
import { type ThemeColor } from '@sites/site-theme/src/types';
import { THEME_COLORS_VARIABLES } from '@sites/site-theme/src/config/css-variables';
import { COLOR_PICKER_PRESETS } from '@components/sp-color-picker/src/constants/color-picker-presets.const';

function isRGBA(val: string): boolean {
    return val.includes('rgba');
}

function hexToRgb(hex, isRgba: boolean): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return isRgba ? `rgba(${r},${g},${b},1)` : `rgb(${r},${g},${b})`;
}

export function getColorMap(themeColorArr: ThemeColor[]): string[] {
    const colorMap = [];

    themeColorArr.forEach((el) => {
        colorMap.push(`${el.value}`);
        colorMap.push(el.name);
    });

    COLOR_PICKER_PRESETS.forEach((arr) => arr.forEach((el) => colorMap.push(...[el, el])));

    return colorMap;
}

export function getVarColor(val: any, selectedThemeColors: any): string {
    const colorName = selectedThemeColors().filter(
        (el) => el.value.replace(/\s/g, '') === hexToRgb(val.value, isRGBA(el.value))
    )[0]?.name;
    return colorName ? `var(${THEME_COLORS_VARIABLES[colorName]})` : val.value;
}

export function updateEditorsState(themeColors: ThemeColor[], editor: Editor): void {
    editor.settings.color_map = getColorMap(themeColors);
    editor.settings.formats = {
        forecolor: {
            inline: 'span',
            classes: 'forecolor',
            styles: { color: (v) => getVarColor(v, () => themeColors) },
        },
    };

    editor.remove();
    tinymce.init({ ...editor.settings, deprecation_warnings: false });
}
